import React from 'react';

const stats = [
  { value: '7+',   label: 'Hizmet Çeşidi',  desc: 'Tırnak, kirpik ve kaş' },
  { value: '1K+',  label: 'Mutlu Müşteri',  desc: 'Ve büyümeye devam' },
  { value: '10+',  label: 'Yıllık Deneyim', desc: 'Güzellik sektöründe' },
  { value: '4.9★', label: 'Müşteri Puanı',  desc: '1000+ değerlendirme' },
];

const Stats: React.FC = () => {
  return (
    <section className="stats-section">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, i) => (
            <div key={i} className="stat-item">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-desc">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
